import React, {useEffect, useState} from "react";
import './Error.scss';
import {ThemedLottiePlayerComponent} from "../../components/common/lottie-player/ThemedLottiePlayerComponent";
import {ButtonComponent} from "../../components/common/button/ButtonComponent";
import {useThemeSelector} from "../../hooks/theme/useThemeSelector";
import {isMobileDevice} from "../../utils/WindowUtils";

export const ErrorPage: React.FC = () => {

    const { theme } = useThemeSelector()
    const [supportLink, setSupportLink] = useState("")

    useEffect(() => {
        if (theme === "squareone") {
            setSupportLink("https://getsquareone.app/")
        } else if (theme === "emerge") {
            setSupportLink("https://www.emerge.nz/")
        }
    }, [theme]);


    return (
        <div className={`background-complete general-container result-container height-window 
        ${isMobileDevice() ? 'tertiary-blue-background' : ''}`}>
            <div className={`flex-center error-lottie-container`}>
                <ThemedLottiePlayerComponent animation="error"/>
            </div>
            <div className={`flex-center error-text-container`}>
                <span className={`font-white general-title general-error-title error-title-font`}>
                    Something went wrong.
                </span>
                <span className={`flex-center font-white general-subtitle error-title-text`}>
                    Close this window using X and try again with the same ID type.
                </span>
            </div>
            <div className={'flex-center width-full error-button-container'}>
                <ButtonComponent label='Contact support' onButtonClick={() => {
                    window.location.href = supportLink
                }}/>
            </div>
        </div>
    )
}